jQuery(document).ready(function($) {
    $('.social-menu a').attr("target","_blank");
});


jQuery(document).ready(function($) {
    $('.js-print').on('click', function(e) {

        // Content to hide
        var elsToHide$ = $('.wrapper')
            .add('.tooltip')
            .add('.curtain')
            .add('.scrollTo_top')
            .add('.jquery-modal');

        // Hide content
        elsToHide$.addClass('is-hidden');

        // Clone the element to print and give it a unique class to remove it later
        $('.js-print-this')
            .clone()
            .addClass('js-is-printable')
            .appendTo('body');

        // Print the page
        window.print();

        // Remove the cloned content
        $('.js-is-printable').remove();

        // Show content
        elsToHide$.removeClass('is-hidden');
    });
});


// WEBPACK FOOTER //
// ./resources/js/theme.js